import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import { getTokenFromCookie } from "../utils/Utility";
import { showHideLoadingDialog } from "../redux/slice/commonSlice";

let stompClient: Client | null = null;
let dispatch: any;
let isConnected = false;

export const setWsDispatch = (dispatchFunction: any) => {
  dispatch = dispatchFunction;
};

export const createWebSocketClient = (onConnectHandler?: () => void): Client | null => {
  const token = getTokenFromCookie();
  const wsBaseUrl = process.env.REACT_APP_WS_BASE_URL;

  if (!wsBaseUrl) {
    console.error("REACT_APP_WS_BASE_URL is not defined");
    return null;
  }

  stompClient = new Client({
    reconnectDelay: 5000,
    webSocketFactory: () =>
      new SockJS(`${wsBaseUrl}?jwtToken=Bearer ${token}`),
    onConnect: () => {
      isConnected = true;
      console.log("WebSocket connected");
      if (onConnectHandler) onConnectHandler(); 
    },
    onDisconnect: () => {
      isConnected = false;
      console.log("WebSocket disconnected");
    },
    onStompError: (frame) => {
      console.error("Broker reported error: ", frame.headers["message"]);
      console.error("Additional details: ", frame.body);
    },
    onWebSocketError: (event) => {
      console.error("WebSocket error:", event);
    },
    beforeConnect: () => {
      if (dispatch) {
        dispatch(showHideLoadingDialog(true));
      }
    },
    onWebSocketClose: () => {
      if (dispatch) {
        dispatch(showHideLoadingDialog(false));
      }
    },
  });

  return stompClient;
};

export const getStompClient = (): Client | null => stompClient;

export const disconnectWebSocket = () => {
  if (stompClient?.connected) {
    stompClient.deactivate();
    isConnected = false;
    console.log("WebSocket connection closed.");
  }
};

export const isWebSocketConnected = () => isConnected;
